var app = angular.module("leonardo");

var ManageByFilter = function($scope, AuthDataService, FilterService) {

  $scope.managers = [];

  if (AuthDataService.authData.account) {
    $scope.managers.push({
      id: AuthDataService.authData.account.id,
      name: AuthDataService.authData.account.name
    });
    angular.forEach(AuthDataService.authData.account.managed_to_me, function (value) {
      $scope.managers.push(value);
    });
  }

  $scope.showFilter = function () {
    return ($scope.managers.length > 1);
  };

  $scope.$on('$destroy', function () {
    FilterService.clearFilters(true);
  });

};

app.controller('ManageByFilter', ['$scope', 'AuthDataService', 'FilterService', ManageByFilter]);
